import { computed } from 'vue';
import { useQueryV2 } from '@libs/use';
import { WatchlistOverviewQuery } from '@libs/api-reference';

import * as API from '../requests';
import { WATCHLIST_QUERY_KEYS } from '../constants';

export default function useGetWatchlistOverview() {
  const {
    execute: getWatchlistOverview,
    result,
    ...query
  } = useQueryV2<WatchlistOverviewQuery>(API.getWatchlistOverview, {
    key: WATCHLIST_QUERY_KEYS.watchlistOverview,
  });

  const watchListOverview = computed(() => result.value?.data || []);

  return {
    getWatchlistOverview,
    watchListOverview,
    ...query,
  };
}
